import React from "react";

export default function GlobalLoader() {
  return (
    <div style={{
      position:"fixed",inset:0,zIndex:999998,
      backdropFilter:"blur(4px)",WebkitBackdropFilter:"blur(4px)",
      background:"rgba(0,0,0,0.35)",
      display:"flex",alignItems:"center",justifyContent:"center",
      pointerEvents:"all",
    }}>
      <div style={{
        background:"#fff",borderRadius:"20px",
        padding:"32px 44px",
        display:"flex",flexDirection:"column",
        alignItems:"center",gap:"16px",
        boxShadow:"0 24px 64px rgba(0,0,0,0.2)",
        fontFamily:"'Inter',-apple-system,sans-serif",
      }}>
        <div style={{position:"relative",width:52,height:52}}>
          <div style={{
            width:"52px",height:"52px",
            border:"4px solid #dcfce7",
            borderTop:"4px solid #16a34a",
            borderRadius:"50%",
            animation:"ta-spin 0.8s linear infinite",
          }}/>
          <div style={{
            position:"absolute",top:"50%",left:"50%",
            transform:"translate(-50%,-50%)",
            width:20,height:20,
            background:"linear-gradient(135deg,#16a34a,#22c55e)",
            borderRadius:"50%",
          }}/>
        </div>
        <p style={{margin:0,fontSize:"15px",fontWeight:"700",color:"#111827"}}>Please wait...</p>
        <p style={{margin:0,fontSize:"12px",color:"#9ca3af"}}>Processing your request</p>
      </div>
      <style>{`@keyframes ta-spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}`}</style>
    </div>
  );
}
